import React from 'react';

const ScrewDriverIcon = ({ width = '25', height = '25' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M8.35539 13.0242C8.55792 12.8217 8.83257 12.708 9.11895 12.708C9.40533 12.708 9.67998 12.8217 9.88251 13.0242L12.1743 15.3138C12.2748 15.4141 12.3546 15.5333 12.4091 15.6645C12.4635 15.7957 12.4916 15.9364 12.4916 16.0785C12.4916 16.2205 12.4635 16.3612 12.4091 16.4924C12.3546 16.6236 12.2748 16.7428 12.1743 16.8431L7.20627 21.8111C6.95524 22.0616 6.65733 22.2601 6.32955 22.3955C6.00177 22.5308 5.65055 22.6003 5.29594 22.5999C4.94132 22.5995 4.59026 22.5292 4.26279 22.3931C3.93532 22.2571 3.63786 22.0578 3.38739 21.8068C2.88155 21.2998 2.59782 20.6126 2.59863 19.8964C2.59944 19.1803 2.88472 18.4937 3.39171 17.9879L8.35539 13.0242Z"
      stroke="#222222"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.5596 7.47918L17.7196 9.63918L19.8796 9.09918L22.0396 5.31918L19.8796 3.15918L16.0996 5.31918L15.5596 7.47918Z"
      stroke="#222222"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0273 14.1712L16.639 8.55957"
      stroke="#222222"
      strokeWidth="2.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ScrewDriverIcon;
